import { render, staticRenderFns } from "./InvestFundCard.vue?vue&type=template&id=392ed302&scoped=true"
import script from "./InvestFundCard.vue?vue&type=script&lang=js"
export * from "./InvestFundCard.vue?vue&type=script&lang=js"
import style0 from "./InvestFundCard.vue?vue&type=style&index=0&id=392ed302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392ed302",
  null
  
)

export default component.exports